import { fetchActivitiesStaticImageLogic } from './fetchActivitiesStaticImageLogic';

export const logic = [fetchActivitiesStaticImageLogic];
